import { render, staticRenderFns } from "./QuickTransportVehicleForm.vue?vue&type=template&id=b930e33a&"
import script from "./QuickTransportVehicleForm.vue?vue&type=script&lang=js&"
export * from "./QuickTransportVehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports